import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function ClippingModal(props) {
  return (
    <div>
      <Dialog
        onClose={props.closeModal}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={props.closeModal}>
          <div style={{ paddingRight: '40px' }}>
            Não foi possível obter as seguintes informações do recorte
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {props.modalValues.parties && (
            <Typography gutterBottom>- Partes</Typography>
          )}
          {props.modalValues.claimant && (
            <Typography gutterBottom>- Reclamante</Typography>
          )}
          {props.modalValues.claimantLawyer && (
            <Typography gutterBottom>- Advogado Reclamante</Typography>
          )}
          {props.modalValues.claimantLawyerOAB && (
            <Typography gutterBottom>
              - Nº. OAB do Advogado Reclamante
            </Typography>
          )}
          {props.modalValues.claimed && (
            <Typography gutterBottom>- Reclamado</Typography>
          )}
          {props.modalValues.claimedLawyer && (
            <Typography gutterBottom>- Advogado Reclamado</Typography>
          )}
          {props.modalValues.claimedLawyerOAB && (
            <Typography gutterBottom>
              - Nº. OAB do Advogado Reclamado
            </Typography>
          )}
          {props.modalValues.processNumber && ( // Necessary to be false because the response problem
            <Typography gutterBottom>- Número do Processo</Typography>
          )}
          {props.modalValues.source && (
            <Typography gutterBottom>- Origem</Typography>
          )}
          {props.modalValues.court && (
            <Typography gutterBottom>- Vara</Typography>
          )}
          {props.modalValues.startDate && (
            <Typography gutterBottom>- Data de Publicação</Typography>
          )}
          {props.modalValues.releaseDate && (
            <Typography gutterBottom>- Data de Disponibilização</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.closeModal} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
